import React from 'react'
import Donate from '../../components/User/Donate/index'


export const DonatePage = () => <Donate />
